<template>
    <div>
        <div class="redeem-btn"
            :class="strButtonClass"
            @click="clickRedeem()"
            v-html="strButtonLabel"></div>
        <!-- <div class="redeem-border"></div> -->
    </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import Util from "@/helper/Utility.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
/**
 * Property
 * @property {boolean} isLogin (required) Is user logged in.
 * @property {number} point (required) User available point.
 * @property {number} selectedPoint (required) Point amount for redeem campaign.
 * @property {number} selectedQuantity (required) Campaign's quantity.
 * @property {object} lblRedeemBTN (required) Text for component.
 * @property {object} campaign (required) Campaign data.
 * @property {object} redeemBTN (required) Redeem information (redeemable, isDisable etc.).
 *
 * Event
 * @event clickRedeem Callback to parent component when click redeem button.
 * Method
 * @method initialRedeemButton Setup redeem button data (text, redeemable, disable css class, etc.).
 *
 * Utilities
 * @method cleanRedeemButtonLabel Replace \n with <br/>.
 * @method getRedeemButtonClass Get redeem current css class.
 */

export default {
    name: "RedeemButton",
    props: {
        isLogin: Boolean,
        point: Number,
        selectedPoint: Number,
        selectedQuantity: Number,
        lblRedeemBTN: Object,
        campaign: Object,
        redeemBTN: Object
    },
    data: function() {
        return {
            strButtonLabel: '',
            strButtonClass: ''
        };
    },
    mounted: function () {
        this.initialRedeemButton();
        this.strButtonClass = this.getRedeemButtonClass();
        this.strButtonLabel = this.cleanRedeemButtonLabel();
        this.trackingGA();
    },
    methods: {
        //Event
        clickRedeem: function () {
            this.$emit('clickRedeem');
        },
        //Function
        trackingGA: function() {
            var label = this.campaign.id + "|" + this.campaign.name;
            var gtm = {
                "event_label": this.campaign.name,
                "privilege_category_name": this.campaign.categoryName,
                "privilege_id": this.campaign.id,
                "timestamp": moment().format("YYYYMMDD HH:mm:ss")
            };
            //var status = this.redeemBTN.strDisableClass.replace("redeem-","")

            Vue.ga.event(this, "privilege", "privilege_detail_impression_Used", label, null, gtm);
        },
        initialRedeemButton: function () {
            //Declare default stuff.
            this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.default;
            this.redeemBTN.isAllowRedeem = this.campaign.isConditionPass;
            this.redeemBTN.isButtonDisable = !this.campaign.isConditionPass;
            //Check is campaign supported.
            if(this.campaign.type == Vue.CampaignType.Bid ||
                this.campaign.type == Vue.CampaignType.Event ||
                this.campaign.type == Vue.CampaignType.Media) {
                this.redeemBTN.isAllowRedeem = false;
                this.redeemBTN.isButtonDisable = true;
                this.redeemBTN.strDisableClass = 'redeem-notsupport';
                this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.notSupport;
                return;
            }
            //Check expire date.
            if(this.campaign.currentDate > this.campaign.expireDate) {
                this.redeemBTN.isAllowRedeem = false;
                this.redeemBTN.isButtonDisable = true;
                this.redeemBTN.strDisableClass = 'redeem-expired';
                this.redeemBTN.strRedeemLabel = this.campaign.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.campaignExpiredBuy : this.lblRedeemBTN.campaignExpired;
                return;
            }
            //Check sold out.
            // if(this.selectedQuantity <= 0) {
            //     this.redeemBTN.isAllowRedeem = false;
            //     this.redeemBTN.isButtonDisable = true;
            //     this.redeemBTN.strDisableClass = "redeem-soldout";
            //     this.redeemBTN.strRedeemLabel = this.campaign.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.soldOutBuy : this.lblRedeemBTN.soldOut;
            //     return;
            // }
            //Do validate when logged in.
            if(this.isLogin) {
                //Check user enough point.
                if(this.selectedPoint > this.point) {
                    if(this.campaign.pointType && this.campaign.pointType != 'use') {
                        //Get point, do nothing.
                    } else {
                        this.redeemBTN.isAllowRedeem = false;
                        this.redeemBTN.isButtonDisable = true;
                        this.redeemBTN.strDisableClass = 'redeem-notenoughpoint';
                        this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.notEnoughPoint;
                        return;
                    }
                }
                //Handle common case for custom text.
                if(!this.campaign.isConditionPass) {
                    this.redeemBTN.isAllowRedeem = false;
                    this.redeemBTN.isButtonDisable = true;
                    //Use api text message.
                    if(this.redeemBTN.isUseDefault) {
                        this.redeemBTN.strDisableClass = 'redeem-condition';
                        this.redeemBTN.strRedeemLabel = this.campaign.conditionAlert;
                    } else {
                        switch(this.campaign.conditionAlertId) {
                            case 0:
                                //Should not happening (case 0 means this campaign can be redeem).
                                this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.none;
                                break;
                            case 1:
                                //Campaign is soldout.
                                this.redeemBTN.strDisableClass = "redeem-soldout";
                                this.redeemBTN.strRedeemLabel = this.campaign.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.soldOutBuy : this.lblRedeemBTN.soldOut;
                                break;
                            case 2:
                                //User already redeem to maximun per person.
                                this.redeemBTN.strDisableClass = "redeem-maxperson";
                                this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.maxPerPerson;

                                if(this.campaign.interfaceDisplay === 'survey' || this.campaign.interfaceDisplay === 'surveyapprove') {
                                    this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.survey_maxPerPerson;
                                }
                                break;
                            case 3:
                                //Campaign is on cooldown.
                                this.redeemBTN.strDisableClass = "redeem-cooldown";
                                if (this.campaign.nextRedeemDate) {
                                    this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.nextDate + DatetimeHelper.dateShortFormat(this.campaign.nextRedeemDate);
                                    if(this.campaign.interfaceDisplay === 'survey' || this.campaign.interfaceDisplay === 'surveyapprove') {
                                        this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.survey_nextDate + DatetimeHelper.dateShortFormat(this.campaign.nextRedeemDate);
                                    }
                                } else {
                                    this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.redeemCoolDown;
                                }
                                break;
                            case 4:
                                //Never see this.
                                this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.exceedBuyPointLimitPerday;
                                break;
                            case 1403:
                                //User cannot redeem due to campaign condition and user level.
                                this.redeemBTN.strDisableClass = "redeem-eligible";
                                this.redeemBTN.strRedeemLabel = this.lblRedeemBTN.conditionIsInvalid; //Not eligible.
                                break;
                            case 1409:
                                //Campaign is already expire.
                                this.redeemBTN.strDisableClass = "redeem-expired";
                                this.redeemBTN.strRedeemLabel = this.campaign.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.campaignExpiredBuy : this.lblRedeemBTN.campaignExpired;
                                break;
                            case 1410:
                                //Campaign is not available.
                                this.redeemBTN.strRedeemLabel = this.campaign.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.campaignNotAvailableBuy : this.lblRedeemBTN.campaignNotAvailable;
                                break;
                            default:
                                //Other case.
                                this.redeemBTN.strDisableClass = "redeem-condition";
                                this.redeemBTN.strRedeemLabel = this.campaign.conditionAlert;
                                break;
                        }
                    }
                } else {
                    if(this.selectedQuantity <= 0) {
                        this.redeemBTN.isAllowRedeem = false;
                        this.redeemBTN.isButtonDisable = true;
                        this.redeemBTN.strDisableClass = "redeem-soldout";
                        this.redeemBTN.strRedeemLabel = this.campaign.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.soldOutBuy : this.lblRedeemBTN.soldOut;
                        return;
                    }


                    this.redeemBTN.strDisableClass = 'redeem-allow';

                    if(this.campaign.customCaption) {
                        this.redeemBTN.strRedeemLabel = this.campaign.customCaption;
                    }
                }

                
            } else {
                this.redeemBTN.strDisableClass = 'redeem-allow';

                if(this.campaign.customCaption) {
                    this.redeemBTN.strRedeemLabel = this.campaign.customCaption;
                }
            }
        },
        //Utilities
        cleanRedeemButtonLabel: function () {
            return Util.newLineToBr(this.redeemBTN.strRedeemLabel);
        },
        getRedeemButtonClass: function () {
            if(!this.redeemBTN.isAllowRedeem)
                return this.redeemBTN.strDisableClass;

            return 'redeem-allow';
        }
    }

}
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";
.redeem-btn {
    width: 100%;
    padding: 15px 15px 15px 15px;
    position: fixed;
    bottom: 0;
    color:white;
    text-align: center;
    font-size: 22px;
    font-weight: 500;
    background-color: $background-gray-btn-cancel-color;

    -webkit-box-shadow: -10px -15px 20px 20px rgba(255, 255, 255, 0.8);
    -moz-box-shadow: -10px -15px 20px 20px rgba(255, 255, 255, 0.8);
    box-shadow: -10px -15px 20px 20px rgba(255, 255, 255, 0.8);

    &.redeem-allow {
        background-image: url('../../../assets/campaign/button_redeem@2x.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
    }
}

.redeem-border {
    position: fixed;
    bottom: 10px;
    width: 50%;
    height: 8px;
    background-color: #aadaf0;
    border-radius: 3px;
    margin-left: 25%;

}
</style>
